module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - Roca Developments Inc. - August 8, 2024.ffca05fc.pdf";